import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES = createRequest(
  'REVERS.IO/GET_ADDITIONAL_INFORMATION_ENTITIES_SUMMARIES',
);
